import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForMexico {
  //#region  OnChange
  static onContractorLocationCountryIdChange(editedItem) {
    editedItem.PaymentMethod = EditFreelancerUserHelper.getDefaultPaymentMethodValue(editedItem);
    editedItem.PaymentCurrencyId = EditFreelancerUserHelper.getDefaultPaymentCurrencyValue(editedItem);
  }
  //#endregion

  //#region Validation
  static validityCheckerForClabe(e) {
    if (ValidityHelper.forRequiredTextField(e) !== '') {
      return ValidityHelper.forRequiredTextField(e);
    }

    const parts = e.split(' ');
    if (parts.length !== 6) {
      return 'Clabe must consist of 18 digits in format: "xxx xxx xxx xxx xxx xxx", without quotes, where x is a digit.';
    }

    for (const element of parts) {
      if (!element || element.length !== 3 || isNaN(element) || isNaN(parseFloat(element))) {
        return 'Clabe must consist of 18 digits in format: "xxx xxx xxx xxx xxx xxx", without quotes, where x is a digit.';
      }
    }

    return '';
  }
  //#endregion

  //#region selectValues
  static getCurrencySelectValues(editedItem) {
    if (editedItem.ContractorLocationCountryId?.toString() === '142') {
      return [101];
    } else {
      return [151];
    }
  }
  //#endregion

  static returnDescriptionTab() {
    return {
      label: 'Mexico Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 14),
      fields: [
        {
          fieldName: 'PaymentCurrencyId',
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          selectvalues: PaymentInformationForMexico.getCurrencySelectValues,
          validityChecker: ValidityHelper.AlwaysFlawless,
          onFieldChange: (item) => {
            item.PaymentCurrencyId = EditFreelancerUserHelper.getDefaultPaymentCurrencyValue(item);
          },
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ContractorLocationCountryId',
          label: 'Contractor Location',
          className: 'col-6',
          type: InputTypesEnum.CountrySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          onFieldChange: PaymentInformationForMexico.onContractorLocationCountryIdChange,
        },
        {
          fieldName: 'Pimxclabe',
          label: 'Clabe',
          className: 'col-6',
          type: InputTypesEnum.Text,
          tooltipText: 'Format: "xxx xxx xxx xxx xxx xxx" (without quotes, where x is a digit)',
          validityChecker: PaymentInformationForMexico.validityCheckerForClabe,
        },
        {
          fieldName: 'PIAccountHolderName',
          label: 'Beneficiary Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIBankName',
          label: 'Bank Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIBankAddress',
          label: 'Bank Address',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: 'Bank Account Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    };
  }
}
